import React, { useState } from "react";
import Input from "./Input";

export default function AnimalNameForm({ onSubmit }) {
    const [name, setName] = useState('');

    const submit = event => {
        event.preventDefault();

        if (name) {
            onSubmit(name);
        }
    };

    return (
        <>
            <form id="animal-name-form" className="tsc-form" onSubmit={submit}>
                <div className="question">
                    <Input
                        label="What Is Your Horse's Name?"
                        name="horse-name-input"
                        placeholder="Type the name"
                        type="text"
                        value={name}
                        onChange={val => setName(ensureUpperCaseFirstLetter(val))}
                        maxLength="16"
                        autoComplete="false"
                    />
                </div>
                <div className="button-row">
                    <input className="tsc-button" type="submit" value="Start" disabled={!name} />
                </div>
            </form>
        </>
    );
}

function ensureUpperCaseFirstLetter(val){
    return val.slice(0, 1).toUpperCase() + val.slice(1);
}